export interface OnRoutesInit {
  $onRoutesInit(): void | Promise<any>;
}
